import React from 'react'
import ReactDOM from 'react-dom'

class Portal extends React.Component<{
  containerDom?: HTMLElement
  visible: boolean
  className?: string
  didMount?: () => void
  unMount?: () => void
}> {
  constructor(props) {
    super(props)
    const { className } = props
    // 初始化创建渲染的父元素并添加到body下
    this.node = document.createElement('div')
    this.node.className = `du-portal ${className || ''}`
    const containerDom = props.containerDom || document.body
    containerDom.appendChild(this.node)
    this.containerDom = containerDom
  }

  node: HTMLElement
  containerDom: HTMLElement

  componentDidMount() {
    if (typeof this.props.didMount === 'function') {
      this.props.didMount()
    }
  }

  componentWillUnmount() {
    if (this.containerDom) {
      this.containerDom.removeChild(this.node)
    }
    if (typeof this.props.unMount === 'function') {
      this.props.unMount()
    }
  }

  render() {
    const { visible, children } = this.props
    // 直接通过显隐表示
    return visible && ReactDOM.createPortal(children, this.node)
  }
}

export default Portal
